// components/layout/Sidebar/Sidebar.tsx - Dark Agentic Theme
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Upload, MessageSquare, Settings } from 'lucide-react';
import { ROUTES } from '../../../constants/routes';
import './Sidebar.css';

const Sidebar: React.FC = () => {
  const location = useLocation();

  const navItems = [
    {
      path: ROUTES.DASHBOARD,
      label: 'Dashboard',
      icon: Home
    },
    {
      path: ROUTES.UPLOAD,
      label: 'Upload',
      icon: Upload
    },
    {
      path: ROUTES.CHAT,
      label: 'Ask Arti',
      icon: MessageSquare
    },
    {
      path: ROUTES.SETTINGS,
      label: 'Settings',
      icon: Settings
    }
  ];

  return (
    <div className="sidebar-dark">
      {/* Header with Artifi Branding */}
      <div className="sidebar-header-dark">
        <div className="artifi-logo">
          <div className="logo-icon-dark">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path 
                d="M12 2L3 7V17L12 22L21 17V7L12 2Z" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="logo-text-dark">
            <span className="logo-primary">Artifi Agentic</span>
            <span className="logo-secondary">App</span>
          </div>
        </div>
        <div className="product-subtitle">Contract Analyzer</div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav-dark">
        <ul className="nav-list-dark">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <li key={item.path} className="nav-item-dark">
                <NavLink
                  to={item.path}
                  className={`nav-link-dark ${isActive ? 'active' : ''}`}
                >
                  <Icon size={18} className="nav-icon-dark" />
                  <span className="nav-label-dark">{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* User Section */}
      <div className="sidebar-footer-dark">
        <div className="user-section">
          <div className="user-avatar-dark">V</div>
          <div className="user-info-dark">
            <span className="user-name-dark">Vinod Srinivasan</span>
            <span className="user-role-dark">Admin</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;